import React from "react";

import { Skeleton } from "components";
import { useLoader } from "hooks";

import ShowIcon from "static/images/eye.png";
import styles from "./../autoCheckList.module.scss";

type MerchantData = {
	address: string;
	fullName: string;
	id: number;
	ip: string | null;
	isp: string | null;
	location: string;
	partialSSN: string;
};

type OwnerHeaderProps = {
	ownerName: string;
	merchantData: MerchantData;
	showOwner: Function;
	loading: boolean;
};

export const OwnerHeader = ({
	ownerName,
	merchantData,
	showOwner,
	loading,
}: OwnerHeaderProps) => {
	const Loader = useLoader(loading);

	return (
		<Loader
			skeleton={
				<Skeleton
					variant="text"
					height="30px"
					width="100%"
					marginBottom="13px"
				/>
			}
			component={
				<div className={styles.wrappOwnerTitle}>
					<div className={styles.ownerNumbers}>{ownerName}</div>
					<div className={styles.wrappFullName}>
						<p className={styles.fullName}>
							{merchantData?.fullName}
						</p>
						<img
							src={ShowIcon}
							alt=""
							className={styles.showOwnerDataIcon}
							onClick={() => showOwner(merchantData)}
						/>
					</div>
				</div>
			}
		/>
	);
};
